import React, { useState } from 'react';
import ImageModal from './ImageModal';

export default function ProjectGallery({ project }) {
  const [openModal, setOpenModal] = useState(false);
  const [modalIndex, setModalIndex] = useState(0);

  const { name, time, description, images, captions = [] } = project;

  const openModalAtIndex = (index) => {
    setModalIndex(index);
    setOpenModal(true);
  };

  return (
    <div className="mb-12 p-6 border rounded-lg shadow bg-white max-w-2xl mx-auto">
      <h2 className="text-2xl font-bold mb-1 text-gray-800">{name}</h2>
      {time && <h3 className="text-md font-medium text-gray-500 mb-2">{time}</h3>}
      {description && <p className="text-gray-600 mb-4">{description}</p>}

      <div className="relative flex justify-center">
        <img
          src={images[0]}
          alt={`Project ${name} - View 1`}
          onClick={() => openModalAtIndex(0)}
          className="w-full max-w-md h-auto object-contain cursor-pointer shadow-lg rounded-lg"
          style={{ filter: 'contrast(1.4) brightness(0.9)' }}
        />

        {captions[0] && (
          <div
            className="absolute bottom-2 left-2 inline-block bg-black bg-opacity-60 text-white text-sm px-3 py-1 rounded"
            style={{ pointerEvents: 'none' }}
          >
            {captions[0]}
          </div>
        )}

        {/* Add a subtle indicator that there are more images */}
        {images.length > 1 && (
          <div className="absolute top-2 right-2 bg-black bg-opacity-60 text-white text-xs px-2 py-1 rounded">
            +{images.length - 1} more
          </div>
        )}
      </div>

      {openModal && (
        <ImageModal
          images={images}
          index={modalIndex}
          setIndex={setModalIndex}
          close={() => setOpenModal(false)}
        />
      )}
    </div>
  );
}